export default __webpack_public_path__ + "static/media/service-titan-logo.f9fa32b1.svg";